export const colors: { [key: string]: string } = {
  white: '#ffffff',
  whitesmoke: '#f4f4f4',
  black: '#000000',
  crimson: '#af0000',
  red: '#ff0000',
  darkgray: '#292929',
  middlegray: '#373737',
  lightgray: '#979797',
  sand: '#fce4ac',
};
